import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './ButtonGroup.scss';

export const ButtonGroup = ({children, theme, className, ...props}) => {
  const styleClassNames = classnames({
    'page-button-group': true,
    [`page-button-group--${theme}`]: !!theme,
    [className]: !!className,
  });
  return (
    <div {...props} className={styleClassNames}>
      {children}
    </div>
  );
};

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['', 'left']),
};

export default ButtonGroup;
